<script>
  export let close;
</script>

<div class="fixed top-0 left-0 w-full h-full bg-gray-700 bg-opacity-75 flex justify-center items-center z-50">
  <div class="relative bg-white rounded-lg w-3/4 h-3/4 overflow-y-scroll p-4">
    <h2 class="text-xl font-bold mb-4 mt-6">Terms of Use for Playfully AI</h2>
            <p 
                class="absolute top-5 right-10 rounded-full text-base font-semibold leading-5 text-gray-800 hover:text-gray-400 cursor-default"
                on:click={close}
            >
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </p>
    
    <h3 class="text-lg font-semibold mt-4">1. Acceptance of Terms</h3>
    <p>By using Playfully AI, you agree to these terms of use. If you do not agree to these terms, please do not use the app.</p>

    <h3 class="text-lg font-semibold mt-4">2. Description of Service</h3>
    <p>Playfully AI is an AI-based role-playing app. It provides an unfiltered AI experience, which means results can be unpredictable.</p>

    <h3 class="text-lg font-semibold mt-4">3. User Responsibility</h3>
    <p>Users should be aware that the AI's outputs can be unexpected. Users are responsible for any actions taken based on the AI's advice or outputs.</p>

    <h3 class="text-lg font-semibold mt-4">4. Age Requirement</h3>
    <p>You must be 18 years or older to use this app. By using Playfully AI, you confirm that you meet this age requirement.</p>

    <h3 class="text-lg font-semibold mt-4">5. Changes to the Terms</h3>
    <p>We may periodically update these terms of use. Please check back regularly to ensure you are aware of any changes.</p>

    <h3 class="text-lg font-semibold mt-4">6. Limitation of Liability</h3>
    <p>Playfully AI, its creators, and affiliates are not responsible for any harm, damage, or negative consequences resulting from the use of the app.</p>

    <button on:click={close} class="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
      Close
    </button>
  </div>
</div>
